import type { API } from 'chessboard/api/config/types';
import type { Game } from 'chessboard/model/game/types';

/**
 * Get the previous node in a line that is the same color as the input node.
 */
export function getPreviousNodeOfSameColor({
  api,
  node,
}: {
  api: API.Extended;
  node: Game.Move.Node;
}): Game.Move.Node | null {
  const previousNode = api.getNodeByIds({ move: node.ids.move - 2, line: node.ids.line });

  return previousNode;
}
